import { createStore, createEffect, createEvent } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils } from '@shared/utils';
import { StatementsApi, type DownloadSepaStatementRequest } from '@shared/api';

interface DownloadSepaStatementEffect extends DownloadSepaStatementRequest {
  name?: string;
}

const downloadSepaStatementEffect = createEffect((request: DownloadSepaStatementEffect) => StatementsApi.downloadSepaStatement(request));
downloadSepaStatementEffect.done.watch((result) => FileUtils.downloadFile(result.result, result.params.name));
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(downloadSepaStatementEffect.pending, (_, data) => data)
  .on(downloadSepaStatementEffect.fail, () => false)
  .on(downloadSepaStatementEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(downloadSepaStatementEffect, () => null)
  // .on(downloadSepaStatementEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(downloadSepaStatementEffect.fail, () => 'Something went wrong while downloading Statement. Please try again.')
  .on(downloadSepaStatementEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $downloadSepaStatementStore = {
  events: {
    downloadSepaStatement: downloadSepaStatementEffect,
    clear: clearEvent,
  },
  store: {
    loading: $loadingStore,
    error: $errorStore,
  },
};
